exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Buttons-module__right___1XuiI,.Buttons-module__wrong___11tgq{cursor:pointer;background-color:#fff;padding:2.5rem;height:230px;text-align:center;border-radius:10px;display:grid;justify-content:center;justify-items:center;align-items:end;z-index:1;position:relative}.Buttons-module__right___1XuiI svg,.Buttons-module__wrong___11tgq svg{font-size:45px}.Buttons-module__right___1XuiI h1,.Buttons-module__wrong___11tgq h1{font-weight:600}.Buttons-module__wrong___11tgq svg{color:#f44e4e}.Buttons-module__right___1XuiI svg{color:#3edc89}", ""]);

// exports
exports.locals = {
	"right": "Buttons-module__right___1XuiI",
	"wrong": "Buttons-module__wrong___11tgq"
};